import { defineRouting } from 'next-intl/routing';
import { defaultLocale, localeCodes } from './locales';

export const routing = defineRouting({
  locales: localeCodes,
  defaultLocale: defaultLocale,
  // Don't show locale prefix for default locale (en)
  // /about-us instead of /en/about-us
  // /en-GB/about-us for non-default locales
  localePrefix: 'as-needed'
});